<template>
    <div>
        <div class="gcmcn-form-title">Add a user</div>
        <div class="gcmcn-card">
            <el-form :model="form" :rules="rules" ref="form">
                <el-form-item class="gcmcn-form-input" prop="email">
                    <div class="gcmcn-form-label">Email</div>
                    <el-autocomplete
                        v-model="form.email"
                        size="mini"
                        value-key="verbose_name"
                        popper-class="gcmcn-popper"
                        :fetch-suggestions="userQuerySearch"
                    ></el-autocomplete>
                    <div class="form-info">
                        Create accounts for users. Select an existing user account or type a new email address.
                    </div>
                </el-form-item>
                <div class="text-right">
                    <el-button
                        type="text"
                        @click="leave"
                    >Cancel</el-button>
                    <el-button
                        :loading="loading"
                        type="primary"
                        class="gcmcn-primary-btn small"
                        @click="validateForm"
                    >Save
                    </el-button>
                </div>
            </el-form>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {

    components: {
    },

    props: {
        users: {
            type: Array,
            required: true
        },
    },

    data (){
        return {
            form: {
                email: '',
            },
            loading: false,
        };
    },

    computed: {
        ...mapGetters([
            'entities',
        ]),
        rules () {
            return {
                email: [{ required: true, message: 'An email is required' }],
            };
        },
    },
    methods: {
        userQuerySearch (queryString, cb){
            let results = this.users.filter((u) => {
                return u.verbose_name.toLowerCase().includes(queryString.toLowerCase());
            });
            cb(results);
        },
        validateForm (){
            this.$refs.form.validate((valid) => {
                if(valid){
                    this.loading = true;
                    let form = JSON.parse(JSON.stringify(this.form));
                    let postData = { model: 'users'};
                    let message;
                    let action;
                    let user = this.users.find((u) => u.email === form.email);
                    if(user){
                         this.$notify({
                            type: 'info',
                            message: `User ${form.email} already exist.`,
                        });
                         this.loading = false;
                         return;
                    }else{
                        postData = form;
                        action = 'fundation/createUserAccount';
                        message = `User ${form.email} successfully created.`;
                    }
                    form.level = 'admin';
                    this.$store.dispatch(action, postData)
                    .then(async (res) => {
                        if(!user){
                            await this.$store.dispatch('fetchModelByName', 'users');
                            this.$store.dispatch('patchItem', {
                                item: {
                                    uid: res.uid,
                                    url: `user/${res.uid}/`,
                                    level: 'admin',
                                },
                                model: 'users'
                            }).then(() => {
                                this.$emit('on-user-created');
                                this.$notify.success({
                                    title: 'Success',
                                    message: message
                                });
                                this.loading = false;
                            }).catch((e) => {
                                throw e;
                            });
                        }else{
                            this.$emit('on-user-created');
                            this.$notify.success({
                                title: 'Success',
                                message: message
                            });
                            this.loading = false;
                        }
                    }).catch((e) => {
                        console.error(e);
                        this.$message.error(`Error on user ${user ? 'update' : 'creation'}.`);
                        this.loading = false;
                    });
                }
            });
        },
        leave (){
            this.$emit('leave-form-view');
        },
    },
};
</script>

<style lang="scss">
.crop-rules{
    text-transform: initial;
    color: #bbb;
}
.inputs-container{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .flex-basis-5{
        flex-basis: calc( 50% - 10px);
    }
    .flex-basis-10{
        flex-basis: 100%;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/page/Setting/Users/user-form.vue